"use client"
import { Patient } from "@/types"
import { PatientCard } from "./patient-card"

interface PatientListProps {
  patients: Patient[];
  onEdit: (patient: Patient) => void;
  onDelete: (id: string) => void;
}

export function PatientList({ patients, onEdit, onDelete }: PatientListProps) {
  if (patients.length === 0) {
    return (
      <div className="text-center py-10 text-muted-foreground">
        No patients found. Add your first patient to get started.
      </div>
    )
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {patients.map((patient) => (
        <PatientCard 
          key={patient.id} 
          patient={patient} 
          onEdit={() => onEdit(patient)} 
          onDelete={() => onDelete(patient.id)} 
        />
      ))}
    </div>
  )
} 